import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './GoBackButton.module.css'
import { useTranslation } from 'react-i18next'
const GoBackButton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation();
  return (
    <button
      className={styles.button}
      onClick={() => navigate(-1)}
    >
      ← {t('GoBackButton.Go Back')}
    </button>
  )
}

export default GoBackButton
